import React from 'react';

import { Badge } from 'antd';
import ToDoListIcon from '../../../../common/icons/ToDoListIcon';

import './NotificationsBadge.css';

export default ({ value, onClick, className }) => (
  <div className={`NotificationsBadge ${className || ''}`} onClick={onClick}>
    <Badge count={value}>
      <ToDoListIcon className="ToDoListIcon" />
    </Badge>
  </div>
);
